import { useState } from 'react';

export function useCollapse(initialState = false) {
  const [isCollapsed, setIsCollapsed] = useState(initialState);

  const toggle = () => setIsCollapsed(!isCollapsed);
  const collapse = () => setIsCollapsed(true);
  const expand = () => setIsCollapsed(false);

  return {
    isCollapsed,
    toggle,
    collapse,
    expand,
  };
}
